// Opens a PDF Blob in a new browser tab and releases the object URL afterwards.

// Delay before revoking the object URL, giving the new tab time to load the PDF.
const REVOKE_DELAY_MS = 60000;

/**
 * Opens a PDF Blob in a new tab (noopener) and revokes the temporary object URL
 * after the new tab has had time to load it. Shared by the template editor and
 * the campaign letter proof so the open/revoke handling lives in one place.
 *
 * @param {Blob} blob - The PDF blob to display.
 * @returns {void}
 */
export function openPdfBlob(blob) {
	const url = URL.createObjectURL(blob);
	window.open(url, '_blank', 'noopener');
	setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
}
